import React from 'react';
import { RoutableRichText } from '../../react/RoutableRichText';

const RichText1 = ({ fields }) =>
  (
    <RoutableRichText field={fields.richText1} tag='section' className='richtext' />
  );

export default RichText1;